import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import Alert from '../components/Alert'
import { useSignUpMutation } from '../RTK/ApiRequests'
import Cookies from 'js-cookie'

const SignUp = () => {
  const [signUpData, setSignUpData] = useState({
    username: "",
    email: "",
    password: ""
  })

  const [alertText, setAlertText] = useState('')
  const [signUp] = useSignUpMutation();

  const handleChange = (e) => {
    setSignUpData({
      ...signUpData,
      [e.target.name]: e.target.value
    })
  }

  const handleClick = async (e) => {
    e.preventDefault()
    const { username, email, password } = signUpData;

    if (!email || !password) return setAlertText("Please fill out all fields")
    else if (!email.endsWith('.com')) {
  setAlertText("Please provide an appropriate email");
    } else if (password.length < 8) {
      setAlertText("Password must be at least 8 characters long");
    } else {
      const res = await signUp({
        email,
        username,
        password
      })


      if (!res.data?.success) {

        if (res.error?.data?.error) {
          setAlertText(res.error?.data?.error);
        } else {
          setAlertText('Unable To create your account');
        }

      } else {
        Cookies.set('msl_ui_tok_id', res.data.token, { expires: 30 });
        window.location.href = '/'
      }
    }
  }

  useEffect(() => {
    setTimeout(() => {
      setAlertText('')
    }, 5000)  
  }, [alertText])


  return (
    <SignUpWrapper>
      <h3>Register</h3>
      <form onSubmit={handleClick}>
        <label htmlFor="username">Username</label>
        <input type="username" id='username' name="username" placeholder='Username' value={signUpData.username} onChange={handleChange} />
        <label htmlFor="email">Email</label>
        <input type="email" id='email' name="email" placeholder='Email' value={signUpData.email} onChange={handleChange} />
        <label htmlFor="password">Password</label>
        <input type="password" id='password' name='password' placeholder='Password' value={signUpData.password} onChange={handleChange} style={{
          marginBottom: '2rem',
        }} />
        {
          alertText !== '' ? <Alert content={alertText} /> : null
        }
        <button type='submit'>REGISTER</button>
      </form>

    </SignUpWrapper>
  )
}

const SignUpWrapper = styled.section`
  margin: 5rem auto;
  border-radius: 5px;

  h3 {
    padding: 10px;
    background-color: #494949;
    color: #fff;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
  }
  
  form {
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 30px 60px;
    background-color: #fff;
    border: 2px solid #C7DCDF;
    border-radius: 4px;

    label {
      cursor: pointer;
      font-size: 20px;
      font-weight: 700;
      line-height: 1.25;
      color: #494949;
      margin-bottom: 5px;
    }

    input {
      outline: none;
      background-color: #F0F2F6;
      border: 2px solid #58678C;
      border-radius: 4px;
      padding: 10px 40px 10px 15px;
      color: #494949;
      font-size: 16px;
      display: block;
      width: 100%;
      z-index: 1;
      position: relative;
      width: 100%;
      text-transform: unset;
    }

    button {
      display: block;
      border: none;
      color: #fff;
      text-align: center;
      font-weight: 600;
      font-size: 20px;
      padding: 1rem;
      text-transform: uppercase;
      margin-bottom: 0;
      background-color: #3BA61C;
      cursor: pointer;
    }
  }

  p {
    text-align: center;
    padding: 1rem;
  }

  #register {
    background-color: #58678C;
    display: block;
    border: none;
    color: #fff;
    text-align: center;
    font-weight: 600;
    font-size: 20px;
    padding: 1rem;
    text-transform: uppercase;
    margin-bottom: 0;
    cursor: pointer;
    width: 100%;
    margin: 0 auto;
  }

`

export default SignUp
